|
<template>
  <ejs-dialog
    ref="formDialog"
    id="dataMaps-form"
    class="dialog-papirus"
    target="#dialogDataMaps"
    :isModal="true"
    :visible="showing"
    :header="header"
    :width="width"
    :showCloseIcon="true"
    :close="onDialogClose"
    :open="onDialogOpen"
    z-index="1003"
  >
    <div id="formatsToast"></div>
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="row" v-show="showId">
          <div class="col-xs-12 col-sm-12 col-lg-2 col-md-2">
            <label class="e-text">Id DataMap</label>
            <input
              id="id"
              class="e-input"
              v-model="m_data.id"
              type="text"
              disabled
              @blur="validateField('id')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-4 col-md-4">
            <label class="e-text">Llave</label>
            <input
              id="key"
              class="e-input"
              :class="{ 'e-warning': hasError('key') }"
              type="text"
              required
              v-model="m_data.key"
              :readonly="isFormReadOnly"
              @input="validateField('key')"
              @blur="validateField('key')"
              placeholder="Llave"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('key') }"
              v-text="m_errors.key"
            >
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-8 col-md-8">
            <label class="e-text">Nombre</label>
            <input
              id="name"
              class="e-input"
              :class="{ 'e-warning': hasError('name') }"
              type="text"
              required
              v-model="m_data.name"
              :readonly="isFormReadOnly"
              @input="validateField('name')"
              @blur="validateField('name')"
              placeholder="Nombre"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('name') }"
              v-text="m_errors.name"
            >
            </span>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label class="e-text">Descripción: </label>
            <input
              id="description"
              class="e-input"
              :class="{ 'e-warning': hasError('description') }"
              type="text"
              required
              v-model="m_data.description"
              :readonly="isFormReadOnly"
              @input="validateField('description')"
              @blur="validateField('description')"
              placeholder="descripcion: "
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('description') }"
              v-text="m_errors.description"
            >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
            <ejs-checkbox
              label="Es Consulta SQL"
              :checked="m_data.isQuery"
              v-model="m_data.isQuery"
              @change="checkboxChanged"
              :disabled="isFormReadOnly"
            ></ejs-checkbox>
          </div>
          <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6">
            <ejs-checkbox
              label="Múltiples Filas en el resultado"
              :checked="m_data.isArray"
              v-model="m_data.isArray"
              :disabled="isFormReadOnly || !m_data.isQuery"
            ></ejs-checkbox>
          </div>
        </div>
        <div class="row" v-show="m_data.isQuery">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <label class="e-text">Consulta</label>
            <textarea
              id="sqlQuery"
              class="e-input"
              :class="{ 'e-warning': hasError('sqlQuery') }"
              type="text"
              required
              rows="5"
              v-model="m_data.sqlQuery"
              :readonly="isFormReadOnly"
              @blur="validateField('sqlQuery')"
              placeholder="Consulta"
            />
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('sqlQuery') }"
              v-text="m_errors.sqlQuery"
            >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <div><label class="e-text">Campos del DataMap</label></div>

            <ejs-grid
              ref="gridDatamapFields"
              class="r-space"
              :actionBegin="onDataMapsActionBegin"
              :actionComplete="onDataMapsActionComplete"
              :toolbar="customToolbar"
              :dataSource="gridData"
              locale="es-CO"
              :query="query"
              :allowSorting="false"
              :allowSelection="true"
              :allowExcelExport="false"
              :allowFiltering="false"
              :selectionSettings="selectionSettings"
              :allowPaging="true"
              :allowGrouping="false"
              :pageSettings="pageSettings"
              :resizeSettings="resizeSettings"
              :editSettings="editSettings"
              :filterSettings="filterSettings"
              :columns="gridColumns"
            ></ejs-grid>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('listaDataMapFields') }"
              v-html="m_errors.listaDataMapFields"
            >
            </span>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12">
            <div class="e-btn-group">
              <ejs-button
                @click.native="validateForm"
                :isPrimary="true"
                iconCss="e-icons icon-save inline-command"
                cssClass="e-flat e-noback"
                v-if="showSaveButton"
                :disabled="disableButtons"
                >Grabar</ejs-button
              >
              <ejs-button
                :isDanger="true"
                iconCss="e-icons icon-trash inline-command"
                cssClass="e-flat e-danger e-noback"
                v-if="showDeleteButton"
                :disabled="disableButtons"
                >Desactivar
              </ejs-button>
              <ejs-button
                @click.native="close()"
                iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback"
                :disabled="disableButtons"
                >Cancelar</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
import Vue from "vue";

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
// import CultureMixin from "../../mixins/CultureMixin";

/* Plugins de Syncfusion */
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";
import { DropDownList } from "@syncfusion/ej2-dropdowns";

/* Utilidades Syncfusion */
import {
  createSpinner,
  showSpinner,
  hideSpinner
} from "@syncfusion/ej2-popups";

import {
  GridPlugin,
  Edit,
  Filter,
  Page,
  Selection,
  CommandColumn,
  Toolbar,
  Sort
} from "@syncfusion/ej2-vue-grids";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(CheckBoxPlugin);
Vue.use(GridPlugin);
Vue.use(DialogPlugin);
Vue.use(ButtonPlugin);
Vue.use(SwitchPlugin);
Vue.use(DropDownListPlugin);
Vue.use(TooltipPlugin);
Vue.use(DropDownListPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin],
  computed: {
    showId() {
      return this.formAction !== FormActionEnum.ADD;
    },
    showSaveButton() {
      return (
        this.formAction === FormActionEnum.ADD ||
        this.formAction === FormActionEnum.EDIT
      );
    },
    showDeleteButton() {
      return this.formAction == FormActionEnum.DELETE;
    },
    customClass() {
      return {
        "dialog-papirus": true,
        "dialog-edit":
          this.formAction == FormActionEnum.ADD ||
          this.formAction == FormActionEnum.EDIT,
        "dialog-view": this.formAction == FormActionEnum.VIEW,
        "dialog-delete": this.formAction == FormActionEnum.DELETE
      };
    },
    isFormReadOnly() {
      var ret = false;

      switch (this.formAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    },
    header() {
      if (this.formAction === FormActionEnum.ADD) {
        return "Nuevo Mapeo De Datos";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Mapeo De Datos";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Mapeo De Datos";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Mapeo De Datos";
      }
      return "";
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    },
    disableButtons() {
      return this.isSaving;
    },
    dataMapsList() {
      let dataMaps = this.$store.getters["dataMaps/allDataMaps"];
      const newArray = JSON.parse(JSON.stringify(dataMaps));
      return newArray
        .filter(function (formatType) {
          return formatType.isActive === true;
        })
        .map(function (row) {
          return { id: row.id, name: row.description };
        });
    },
    customToolbar() {
      //var canCreate = this.hasPermission("CanCreate");
      var canEdit = this.hasPermission("CanEdit");
      var toolbar = [];
      if (canEdit) toolbar.push("Add");
      if (canEdit) toolbar.push("Edit");
      if (canEdit) toolbar.push("Delete");
      toolbar.push("Update");
      toolbar.push("Cancel");
      return toolbar;
    },
    editSettings() {
      var canEdit = this.hasPermission("CanEdit");
      //var canDelete = this.hasPermission("CanEdit");

      return {
        showDeleteConfirmDialog: true,
        allowEditing: canEdit,
        allowEditOnDblClick: false,
        allowAdding: canEdit,
        allowDeleting: canEdit,
        mode: "Normal"
      };
    },
    canEdit() {
      if (!this.hasPermission("CanEdit")) {
        return false;
      }
      return true;
    }
  },
  data() {
    var instance = this;
    return {
      /* Datos del Componente*/
      isValid: false,
      isSaving: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      fields: { text: "name", value: "id" },
      isModal: true,
      target: document.getElementById("dialog"),
      width: this.isMobile ? "90%" : "70%",
      valueTypes: [],
      gridData: [],
      gridColumns: [],
      toolTip: "",
      pageSettings: { pageCount: 5, pageSize: 10 },
      filterSettings: {
        mode: "Immediate",
        immediatemodedelay: 0,
        type: Browser.isDevice ? "Menu" : "FilterBar",
        columns: [],
        ignoreAccent: true
      },
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      resizeSettings: { mode: "Normal" },
      query: "",
      customAttributes: { class: "check" },
      isInGridEdition: false,
      intParams: {
        params: {
          validateDecimalOnType: false,
          decimals: 0,
          format: "N"
        }
      },
      valueElement: null,
      valueCombo: null,

      valueParams: {
        create: () => {
          instance.valueElement = document.createElement("input");
          return instance.valueElement;
        },
        read: () => {
          return instance.getValueTypeById(instance.valueCombo.value);
        },
        destroy: () => {
          instance.valueCombo.destroy();
        },
        write: (args) => {
          instance.valueCombo = new DropDownList({
            dataSource: instance.valueTypes,
            fields: { value: "id", text: "name" },
            placeholder: "Tipo de Dato",
            floatLabelType: "Never"
          });
          instance.valueCombo.value =
            instance.getValueTypeFromText(args.rowData.valueTypeIdCombo) ??
            null;
          instance.valueCombo.appendTo(instance.valueElement);
        }
      }
    };
  },
  created() {},
  async mounted() {
    try {
      createSpinner({
        target: this.$refs.formDialog.$el
      });
    } catch (error) {
      console.log(error);
    }
    try {
      this.buildYupSchema();
      await this.$store.dispatch("valueTypes/getValueTypes");
      this.valueTypes = JSON.parse(
        JSON.stringify(this.$store.getters["valueTypes/allValueTypes"])
      );
      this.gridColumns = this.getGridColumns();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {},
  provide: {
    grid: [Edit, Sort, Filter, Page, Selection, Toolbar, CommandColumn]
  },
  methods: {
    async onDialogOpen() {
      try {
        this.showSpinner();

        this.m_data = Object.assign({}, this.formData);
        this.m_data.dataMaps = [];

        if (this.formAction == FormActionEnum.ADD) {
          this.m_data.isTemplate = true;
          this.m_data.isNew = true;

          //si es nuevo la lista no se setea
        }
        if (this.formAction != FormActionEnum.ADD) {
          //si es nuevo la lista no se setea
          this.m_data.isNew = false;
          //Obtener toda la información, incluyendo los datamaps.
          await this.$store.dispatch("dataMaps/getDataMap", this.formData.id);
          this.m_data = Object.assign(
            {},
            this.$store.getters["dataMaps/currentDataMap"]
          );
        }

        var items = this.getListData();

        if (items == undefined) this.gridData = [];
        else this.gridData = items;
        this.$refs.gridDatamapFields.ej2Instances.refresh();

        this.showOrHideGridColumns(!this.m_data.isQuery);

        this.hideSpinner();
      } catch (error) {
        console.log(error);
        this.hideSpinner();
      }
    },
    getValueTypeById(id) {
      var value = this.valueTypes.find((x) => x.id == id);
      if (value) return value.id + "-" + value.name;
      else return "";
    },
    getValueTypeFromText(value) {
      if (value == null) return null;
      var values = value.split("-");
      return parseInt(values[0]) || null;
    },
    getGridColumns() {
      var instance = this;
      //Obtener las columnas del Grid.
      var columns = [
        {
          field: "id",
          isPrimaryKey: true,
          isIdentity: true,
          visible: false
        },
        {
          field: "dataMapId",
          visible: false
        },
        {
          field: "key",
          headerText: "Clave",
          textAlign: "Left",
          allowEditing: true,
          width: 100,
          minWidth: 100
        },
        {
          field: "name",
          headerText: "Nombre",
          textAlign: "Left",
          allowEditing: true,
          width: 150,
          minWidth: 150
        },
        {
          field: "description",
          headerText: "Descripción",
          textAlign: "Left",
          allowEditing: true,
          minWidth: 250,
          width: 250
        },
        {
          field: "valueTypeId",
          headerText: "Cod Tipo Dato",
          textAlign: "Left",
          visible: false
        },
        {
          field: "valueTypeIdCombo",
          headerText: "Tipo de Dato",
          minWidth: 250,
          width: 250,
          editType: "dropdownedit",
          edit: instance.valueParams,
          customAttributes: {
            class: "e-dataType"
          }
        },
        {
          field: "isFixedValue",
          headerText: "Valor Fijo",
          textAlign: "Left",
          allowEditing: true,
          editType: "booleanedit",
          displayAsCheckBox: "true",
          width: 90,
          minWidth: 90
        },
        {
          field: "isSystemValue",
          headerText: "Parámetro de Sistema",
          textAlign: "Left",
          allowEditing: true,
          editType: "booleanedit",
          displayAsCheckBox: "true",
          width: 90,
          minWidth: 90
        },
        {
          field: "value",
          headerText: "Valor / Variable",
          textAlign: "Left",
          allowEditing: true,
          width: 150,
          minWidth: 150
        },
        {
          field: "parameterCode",
          headerText: "Código de Parámetro",
          textAlign: "Left",
          allowEditing: true,
          width: 150,
          minWidth: 150
        },
        {
          field: "parameterSubCode",
          headerText: "Subcódigo de Parámetro",
          textAlign: "Left",
          allowEditing: true,
          width: 150,
          minWidth: 150
        }
      ];
      return columns;
    },
    getListData() {
      var instance = this;

      var hasDataMapFields =
        instance.m_data.dataMapFields &&
        instance.m_data.dataMapFields.length > 0;
      if (!hasDataMapFields) return [];

      var currentItems = [];
      if (hasDataMapFields)
        currentItems = JSON.parse(
          JSON.stringify(instance.m_data.dataMapFields)
        );

      var hasValueTypes = this.valueTypes && this.valueTypes.length > 0;
      if (!hasValueTypes) return [];

      if (hasDataMapFields && hasValueTypes) {
        //recuperar los DataMapFields con sus respectivos ValueTypes
        var ret = currentItems.map(function (item) {
          // var valueType = instance.valueTypes.find(
          //   (t) => t.id == item.valueTypeId
          // );

          var returnItem = item;
          returnItem.valueTypeIdCombo = instance.getValueTypeById(
            item.valueTypeId
          );

          return returnItem;
        });
        return ret;
      } else {
        return [];
      }
    },
    addGridItem() {
      var instance = this;

      var newItem = {
        id: 0,
        dataMapId: instance.m_data.id,
        key: null,
        name: null,
        description: null,
        valueTypeId: null,
        valueTypeIdCombo: null,
        isFixedValue: false,
        isSystemValue: false,
        value: null,
        parameterCode: null,
        parameterSubCode: null
      };

      this.gridIntegrationsData.push(newItem);
    },
    async onDataMapsActionBegin(args) {
      if (args.requestType === "filtering") {
        if (args.columns && args.columns.length) {
          args.columns.forEach((col) => {
            col.operator = "contains"; // set the “contains” operator for the ‘CustomerID’ column
          });
        }
      }

      if (args.requestType === "refresh") {
        this.$refs.gridDatamapFields.showSpinner();
      }

      if (
        (args.action === "edit" || args.action === "add") &&
        args.requestType === "save"
      ) {
        if (!this.validateDataMapItems(args.data)) {
          args.cancel = true;
          return;
        }
      }

      if (args.requestType === "delete") {
        let cancel = this.InactivateRowDataMaps(args.data[0]);
        args.cancel = cancel;
        this.$refs.gridDatamapFields.ej2Instances.refresh();
        return;
      }
    },
    onDataMapsActionComplete(args) {
      if (args.requestType === "refresh") {
        this.$refs.gridDatamapFields.hideSpinner();
      }

      if (args.name == "actionComplete" && args.requestType == "cancel") {
        Vue.set(this.m_errors, "listaDataMapFields", "");
      }

      if (
        args.name == "actionComplete" &&
        (args.requestType == "beginEdit" || args.requestType == "beginAdd")
      ) {
        if (!args.cancel) this.isInGridEdition = true;
      }
      if (
        args.name == "actionComplete" &&
        (args.requestType == "save" || args.requestType == "cancel")
      ) {
        if (!args.cancel) this.isInGridEdition = false;
      }
    },
    validateDataMapItems(data) {
      var isValidData = true;
      var listaErrores = [];

      var recordId = "";
      recordId = data.key;
      if (data.key === undefined || data.key.trim().length === 0) {
        recordId = "el registro actual";
        listaErrores.push(
          'Debe especificar una clave para el item "' + recordId + '"'
        );
        isValidData = false;
      }

      if (data.name === undefined || data.name.trim().length === 0) {
        listaErrores.push(
          'Debe especificar un nombre para el item "' + recordId + '"'
        );
        isValidData = false;
      }

      var valueTypeId = this.getValueTypeFromText(data.valueTypeIdCombo);
      if (valueTypeId == null || valueTypeId == undefined || valueTypeId == 0) {
        listaErrores.push(
          'Debe especificar un tipo de dato para:"' + recordId + '"'
        );
        isValidData = false;
      }

      if (!this.m_data.isQuery && !data.isFixedValue && !data.isSystemValue) {
        listaErrores.push(
          'Debe determinar si es Valor Fijo o paramétrico para:"' +
            recordId +
            '"'
        );
        isValidData = false;
      }

      if (
        !this.m_data.isQuery &&
        data.isFixedValue &&
        this.isnullOrWhiteSpace(data.value)
      ) {
        listaErrores.push(
          "Debe especificar un valor para el item " +
            recordId +
            '" en el campo "Valor/Variable"!'
        );
        isValidData = false;
      }

      if (
        !this.m_data.isQuery &&
        data.isSystemValue &&
        this.isnullOrWhiteSpace(data.parameterCode)
      ) {
        listaErrores.push(
          "Debe especificar un valor para el item " +
            recordId +
            '" en el campo "Código de Parámetro"!'
        );
        isValidData = false;
      }

      if (
        data.isSystemValue &&
        this.isnullOrWhiteSpace(data.parameterSubCode)
      ) {
        listaErrores.push(
          "Debe especificar un valor para el item " +
            recordId +
            '" en el campo "Subcódigo de Parámetro"!'
        );
        isValidData = false;
      }

      if (!isValidData) {
        var _validaciones = listaErrores.join("<br/>");
        Vue.set(this.m_errors, "listaDataMapFields", _validaciones);
        this.showToast(
          "Validacion fallida",
          "Por favor verifique los errores listados en la parte inferior de los campos del Mapeo de Datos!",
          2000
        );
      } else {
        this.m_errors = {};
      }

      return isValidData;
    },
    isnullOrWhiteSpace(string) {
      return (
        string === null || string === undefined || string.trim().length == 0
      );
    },
    InactivateRowDataMaps(data) {
      // var instance = this;

      // var dDataMaps = JSON.parse(
      // JSON.stringify(instance.m_data.packageDataMaps)
      // );
      // var hasData = dDataMaps && dDataMaps.length > 0;
      // if (!hasData) return false;

      // var localData = JSON.parse(JSON.stringify(data));

      // var existent = dDataMaps.find(
      // (x) =>
      // x.dataMapId: == localData.dataMapId: &&
      // x.id == localData.id
      // );
      // let cancel = existent != undefined && existent != null;
      if (data != null) return false;

      // existent = this.gridData.find(
      // (x) =>
      // x.integrationId == localData.integrationId &&
      // x.packageId == localData.packageId
      // );

      // var delIndex = this.gridData.indexOf(existent);
      // this.$set(this.gridData, delIndex, data);
      // return cancel;
    },
    getDataMapData() {
      var instance = this;
      var hasData = this.gridData && this.gridData.length > 0;
      if (!hasData) return [];
      return this.gridData.map(function (item) {
        var valueTypeId = instance.getValueTypeFromText(item.valueTypeIdCombo);
        return {
          id: item.id,
          dataMapId: item.dataMapId,
          key: item.key,
          name: item.name,
          valueTypeId: valueTypeId,
          description: item.description,
          isFixedValue: item.isFixedValue,
          isSystemValue: item.isSystemValue,
          value: item.value,
          parameterCode: item.parameterCode,
          parameterSubCode: item.parameterSubCode
        };
      });
    },
    checkboxChanged() {
      if (!this.m_data.isQuery) this.m_data.isArray = false;
      this.showOrHideGridColumns(!this.m_data.isQuery);
    },
    showOrHideGridColumns(bShow) {
      if (this.$refs.gridDatamapFields.ej2Instances.columns.length > 0) {
        for (
          var i = 0;
          i < this.$refs.gridDatamapFields.ej2Instances.columns.length;
          i++
        ) {
          var col = this.$refs.gridDatamapFields.ej2Instances.columns[i];
          if (
            col.field == "isFixedValue" ||
            col.field == "isSystemValue" ||
            col.field == "value" ||
            col.field == "parameterCode" ||
            col.field == "parameterSubCode"
          ) {
            this.$refs.gridDatamapFields.ej2Instances.columns[i].visible =
              bShow;
          }
        }
      }
      this.$refs.gridDatamapFields.ej2Instances.refresh();
    },
    onDialogClose() {
      try {
        this.clearErrors();
        this.m_data = {
          id: 0,
          key: "",
          name: "",
          description: "",
          isQuery: false,
          isArray: false,
          sqlQuery: "",
          parentId: null,
          dataMapFields: []
        };
        this.m_errors = [];
        this.$emit("formClosed");
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.$refs.formDialog.hide();
      this.onDialogClose();
    },
    showSpinner() {
      showSpinner(this.$refs.formDialog.$el);
    },
    hideSpinner() {
      hideSpinner(this.$refs.formDialog.$el);
    },
    clearErrors() {
      this.m_errors = {};
    },
    async saveData() {
      try {
        this.isSaving = true;

        var data = this.getDataMapData();

        this.m_data.dataMapFields = data;
        this.showSpinner();
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            this.m_data.isActive = true;
            await this.$store.dispatch("dataMaps/createDataMap", this.m_data);
            this.showToast("Confirmación", "Registro Creado!", 2000);
            this.$emit("onDataChange");
            break;
          case FormActionEnum.EDIT:
            await this.$store.dispatch("dataMaps/updateDataMap", {
              id: this.m_data.id,
              datamap: JSON.parse(JSON.stringify(this.m_data))
            });
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            this.$emit("onDataChange");
            break;
        }

        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.isSaving = false;
          this.hideSpinner();
          this.close();
        }, 500);
      } catch (error) {
        console.log(error);
        this.isSaving = false;
        this.hideSpinner();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    buildYupSchema() {
      this.validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        id: Yup.number().nullable(),
        key: Yup.string().required().max(64).label("Clave"),
        name: Yup.string().required().max(256).label("Nombre DataMap"),
        description: Yup.string().nullable().max(1024).label("Descripción"),
        isQuery: Yup.boolean(),
        isArray: Yup.boolean(),
        sqlQuery: Yup.string()
          .when(["isQuery"], {
            is: true,
            then: Yup.string().required(),
            otherwise: Yup.string().nullable()
          })
          .label("Consulta SQL")
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");

      if (this.isFormReadOnly) return;

      this.validationSchema.validateAt(field, this.m_data).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
      });

      if (field == "sqlQuery") {
        var isValid = this.checkForValidSql();
        if (!isValid)
          Vue.set(
            this.m_errors,
            "sqlQuery",
            "El campo SQL contiene una cadena SQL no válida o potencialmente peligrosa"
          );
      }
    },
    async validateForm() {
      var instance = this;
      try {
        await this.validationSchema.validate(this.m_data, {
          abortEarly: false
        });

        // Validar si es Query SQL entonces que no tenga nada de sentencias de DDL ni INSERT, UPDATE, DELETE (Debe ser Sólo consulta o Exec de un SP);
        var isValid = this.checkForValidSql();
        if (!isValid) {
          Vue.set(
            this.m_errors,
            "sqlQuery",
            "El campo Consulta contiene una cadena SQL no válida o potencialmente peligrosa"
          );
          return;
        }

        if (this.isInGridEdition) {
          this.showToast(
            "Validación!",
            "Debe Aceptar los cambios en los Parámetros antes de continuar",
            2000
          );
          return;
        }

        this.gridData.some(function (item) {
          var itemValid = instance.validateDataMapItems(item);
          if (!itemValid) {
            isValid = false;
            return true;
          }
        });
        if (!isValid) return;

        this.m_errors = {};
        await this.saveData();
      } catch (error) {
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
        });
      }
    },
    checkForValidSql() {
      var value = this.m_data.sqlQuery.toLowerCase();

      var hasMatch =
        /(^|\s)(create|alter|drop)(?=((^|\s*)(table|schema|procedure|proc|database|view|function|trigger|constraint)))/.test(
          value
        );

      if (!hasMatch)
        hasMatch = /(^|\s)(select|insert)((.*\s*into)|(\s*.*\s*into))/.test(
          value
        );

      if (!hasMatch)
        hasMatch = /(^|\s)(update)((.*\s*set)|(\s*.*\s*set))/.test(value);

      if (!hasMatch)
        hasMatch =
          /(^|\s)(delete)((.*\s*(from|where))|(\s*.*\s*(from|where)))/.test(
            value
          );

      //Probar la cadena contra las expresiones regulares.

      return !hasMatch;
    },
    radioChange(args) {
      this.m_data.isFile = false;
      this.m_data.isTemplate = false;
      if (args.value == "isFile") this.m_data.isFile = true;
      if (args.value == "isTemplate") this.m_data.isTemplate = true;
    }
  },
  props: {
    /** Whether the dialog is currently showing */
    showing: {
      type: Boolean,
      required: true,
      default: false
    },
    formAction: {
      type: Number,
      required: true,
      default: 0
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return {
          id: 0,
          formatTypeId: 0,
          name: "",
          pageSize: "",
          pageOrientation: "",
          fileLocation: "",
          isUrl: false,
          isFile: false,
          isTemplate: false,
          isActive: false
        };
      }
    }
  }
});
</script>

<style scoped>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../form-icons.css);

.classEspecial {
  align-self: center;
}

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

.e-listview {
  background: #fff;
  border-color: #999;
  color: #666;
  border: 1px solid;
}
.e-listview:focus {
  border-color: #0078d6;
  color: #fff;
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }

  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }

  .content-wrapper div.row {
    padding: 0px;
  }
}

.e-grid .e-dataType {
  width: 180px !important;
}
</style>
